export default __webpack_public_path__ + "static/media/Group 6401@3x.945540c3.png";